<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}: <i v-if="optional" class="text-gray-400 text-sm">optionnelle</i></label>
    <input :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: error,'bg-gray-100': disabled }"  :type="type" :value="value" @input="$emit('input', $event.target.value)">
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: null,
    label: String,
    error: String,
    optional: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
